<script lang="ts">
  import type { Snippet } from 'svelte';

  type Props = {
    numColumns?: number;
    breakpoint?: number;
    gap?: string;
    width?: string;
    children?: Snippet;
  };

  let {
    numColumns = 3,
    breakpoint = 768,
    gap = '10px',
    width = 'wide',
    children,
  }: Props = $props();

  let windowWidth = $state(Number.POSITIVE_INFINITY);

  const safeNumColumns = $derived(Math.max(1, Math.floor(numColumns)));
  const isStacked = $derived(windowWidth <= breakpoint);
</script>

<svelte:window bind:innerWidth={windowWidth} />

<div
  class="columns {width}"
  class:is-stacked={isStacked}
  style={`--columns: ${safeNumColumns}; --columns-gap: ${gap};`}
>
  {@render children?.()}
</div>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  .columns {
    display: grid;
    grid-template-columns: repeat(var(--columns), minmax(0, 1fr));
    gap: var(--columns-gap);
    margin: auto;

    &.normal {
      max-width: var(--normal-column-width, 660px);
    }
    &.narrower {
      max-width: var(--narrower-column-width, 330px);
    }

    &.narrow {
      max-width: var(--narrow-column-width, 510px);
    }

    &.wide {
      max-width: var(--wide-column-width, 930px);
    }

    &.wider {
      max-width: var(--wider-column-width, 1200px);
    }

    &.widest {
      max-width: 100%;
    }

    &.fluid {
      width: calc(100% + 30px);
      margin-inline-start: -15px;
      max-width: none;
    }

    &.is-stacked {
      grid-template-columns: 1fr;
    }
  }
</style>
